import AddToCart from "../Elements/AddToCart";
import {useEffect, useRef} from "@wordpress/element";

export default function UpsellsBlock({competitions} ) {

	const containerRef = useRef(null);

	const hasSwiper = typeof window !== "undefined" && typeof window.Swiper !== "undefined" && false;

	useEffect(() => {
		if (!hasSwiper || !containerRef.current) return;

		const swiper = new window.Swiper(containerRef.current, {
			direction: "horizontal",
			loop: true,
			spaceBetween: 15,
			pagination: {
				el: containerRef.current.querySelector(".swiper-pagination"),
				clickable: true,
			},
			breakpoints: {
				640: {
					slidesPerGroup: 1,
					slidesPerView: 2,
				},
			},
		});

		return () => {
			swiper.destroy(true, true);
		};
	}, [hasSwiper]);

	return (
		<div className="zap-checkout-block-upsells">
			<h3>People also added...</h3>

				<div
					ref={containerRef}
					className={hasSwiper ? "zap-checkout-block-upsells-carousel swiper" : "zap-checkout-block-upsells-carousel"}>
					<div className={ hasSwiper ? "swiper-wrapper" : "fallback-grid"}>
					{competitions.map((competition, i) => {
						return (
							<div className="swiper-slide" key={i}>
								<div className="zap-checkout-block-upsells-item">
									{competition.product_image && (
										<div className="zap-checkout-block-upsells-item-thumbnail">
											<a href={competition.product_url}>
												<img src={competition.product_image} alt={competition.product_title}
													 width="80"/>
											</a>
										</div>
									)}
									<div className="zap-checkout-block-upsells-item-meta">
										<h3>
											<a href={competition.product_url} target="_blank" rel="noreferrer">{competition.product_title}</a>
										</h3>
										<div className="zap-checkout-block-upsells-item-price">
											<strong className="price-value">{competition.product_price} </strong>
											<span className="price-suffix">Per Entry</span>
										</div>
									</div>
									<AddToCart competition={competition} qty={1}>
										<i style={{margin: 0}} className="fa fa-plus"></i>
									</AddToCart>
								</div>
							</div>
						);
					})}
				</div>
				<div className="swiper-pagination"></div>
			</div>
		</div>
	);
}